import React, {useState} from 'react';
import {Button, Chip, Divider, Stack} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {Cross} from '@icons/index';
import JobInvoiceFiltersDrawer
  from '@screens/admin/invoices/invoicesValidation/details/filters/JobInvoiceFilters.drawer';
import {JobInvoiceDetailsFilters} from '@screens/admin/invoices/invoicesValidation/details/JobInvoiceDetails.modal';

interface TableFiltersComponentProps {
  filters: JobInvoiceDetailsFilters;
  handleReset: () => void;
  handleSave: (filters: JobInvoiceDetailsFilters) => void;
}

const TableFiltersComponent = (props: TableFiltersComponentProps) => {
  const {filters, handleReset, handleSave} = props;

  const {t} = useTranslation();

  const [openFilters, setOpenFilters] = useState(false);

  return (
    <>
      <Stack alignItems="flex-end" spacing={1}>
        <Stack direction="row" spacing={1.5} height="40px" alignItems="center">
          <Button onClick={handleReset} variant="contained" color="primary" startIcon={<Cross/>} size="small">
            {t('global.resetFilters')}
          </Button>
          <Divider variant="fullWidth" orientation="vertical" sx={{height: '30px'}}/>
          <Button onClick={() => setOpenFilters(true)} variant="outlined" color="primary" size="small">
            {t('global.filters')}
          </Button>
        </Stack>
        {!!Object.keys(filters).length && (
          <Stack direction="row-reverse" alignItems="center" spacing={1}>
            {!!filters.clients?.length && (
              <Chip
                color="primary"
                onDelete={() => handleSave({...filters, clients: []})}
                label={`${t('invoices.invoicesValidation.details.filters.client')} (${filters.clients.length})`}
                size="small"/>
            )}
            {!!filters.clientUnits?.length && (
              <Chip
                color="primary"
                onDelete={() => handleSave({...filters, clientUnits: []})}
                label={`${t('invoices.invoicesValidation.details.filters.clientUnit')} (${filters.clientUnits.length})`}
                size="small"/>
            )}
            {!!filters.clientTypologies?.length && (
              <Chip
                color="primary"
                onDelete={() => handleSave({...filters, clientTypologies: []})}
                label={`${t('invoices.invoicesValidation.details.filters.clientTypology')} (${filters.clientTypologies.length})`}
                size="small"/>
            )}
            {filters.minPrice !== undefined && (
              <Chip
                color="primary"
                onDelete={() => handleSave({...filters, minPrice: undefined})}
                label={`${t('invoices.invoicesValidation.details.filters.minPrice')} (${filters.minPrice})`}
                size="small"/>
            )}
            {filters.maxPrice !== undefined && (
              <Chip
                color="primary"
                onDelete={() => handleSave({...filters, maxPrice: undefined})}
                label={`${t('invoices.invoicesValidation.details.filters.maxPrice')} (${filters.maxPrice})`}
                size="small"/>
            )}
          </Stack>
        )}
      </Stack>
      {openFilters && (
        <JobInvoiceFiltersDrawer
          filters={filters}
          handleSave={(newFilters) => {
            handleSave(newFilters);
            setOpenFilters(false);
          }}
          handleClose={() => setOpenFilters(false)}/>
      )}
    </>
  );
};

export default TableFiltersComponent;